import { WarningAmberRounded } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Typography,
} from "@mui/material";
import React from "react";
import { Scheme } from "../models/schemes";
import { black, greyEnabled, purple, purpleLight, red, redLight } from "../../../theme/colors";

interface Props {
  deleteScheme: boolean;
  selectedSchemeDetails: Scheme;
  deleteSchemeApiCall: () => void;
  setDeleteScheme: (val: boolean) => void;
  submitting?: boolean;
}

export default function DeleteScheme({
  deleteScheme,
  selectedSchemeDetails,
  deleteSchemeApiCall,
  setDeleteScheme,
  submitting = false,
}: Props) {
  return (
    <Dialog open={deleteScheme} onClose={() => !submitting && setDeleteScheme(false)} PaperProps={{ sx: { borderRadius: 4 } }}>
      <DialogContent sx={{ width: 400, maxWidth: "90vw", p: 4, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 56,
            height: 56,
            borderRadius: "50%",
            bgcolor: redLight,
            mb: 2,
          }}
        >
          <WarningAmberRounded sx={{ color: red, fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700} color={black} textAlign="center">
          Delete this scheme?
        </Typography>
        <Typography variant="body2" color={greyEnabled} textAlign="center" mt={0.5}>
          {selectedSchemeDetails?.name
            ? <>You're about to delete <strong>{selectedSchemeDetails.name}</strong>. This action cannot be undone.</>
            : "This action cannot be undone."}
        </Typography>

        <Box display="flex" gap={1.5} width="100%" mt={4}>
          <Button
            fullWidth
            disabled={submitting}
            onClick={() => setDeleteScheme(false)}
            variant="outlined"
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            Cancel
          </Button>
          <Button
            fullWidth
            disabled={submitting}
            onClick={() => deleteSchemeApiCall?.()}
            variant="contained"
            disableElevation
            startIcon={submitting ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : undefined}
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            Delete
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
